<template>
    <v-dialog-old ref="dialog" @hidden="close">
        <fieldset>
            <legend>Параметры выгрузки в excel</legend>
            <label>
                <input v-model="clinicExportOne" type="checkbox">
                <span>Только одну клинику</span>
            </label>
            <v-select
                class="custom-select"
                ref="select"
                @search-change="findClinics"
                @remove="addClinic"
                placeholder="Поиск клиник..."
                :disabled="!clinicExportOne"
                :options="foundClinics"
            >
                <template v-slot="{option}">
                    <div class="textarea">
                        <span>{{ option.text }}</span>
                        <br/>
                        <small>{{ option.address }}</small>
                    </div>
                </template>
            </v-select>

            <date-range-picker
                ref="datepicker"
                @clear-selected="setDate"
            />
        </fieldset>

        <footer>
            <button :class="isEmptyDate ? 'grey' : 'green'" :disabled="isEmptyDate" @click="confirm">Выгрузить</button>
        </footer>
    </v-dialog-old>
</template>

<script>
export default {
    name: "ExportDialog",
    data() {
        return {
            clinicExportOne: false,
            autocompleteKey: 1,
            foundClinics: [],
            selectKey: 0,
            query: '',
            selectClinic: {},
            dateFilter: {}
        }
    },
    computed: {
        isEmptyDate() {
            return Object.keys(this.dateFilter).length === 0 || this.dateFilter?.dateBegin === '' || this.dateFilter?.dateEnd === ''
        }
    },
    methods: {
        open() {
            this.$refs.dialog.show()
        },
        confirm() {
            window.open(`calltracking/get-report/${this.selectClinic?.id ?? ''}?dateBegin=${this.dateFilter.dateBegin}&dateEnd=${this.dateFilter.dateEnd}`)
            this.clinicExportOne = false
            this.autocompleteKey = 1
            this.foundClinics = []
            this.selectKey = 0
            this.query = ''
            this.selectClinic = {}
            this.dateFilter = {}
            this.$refs.dialog.hide()
            this.$refs.dialog.close()
        },

        close() {
            this.selectClinic = {};
            this.dateFilter = {};
            this.$refs.dialog.close()
        },
        findClinics(query) {
            if (query.length > 2) {
                this.findClinicByName(query).then((res) => {
                    this.foundClinics = res.data.suggestions.map(item => {
                        return {
                            id: item.data.id,
                            text: item.data.name,
                            city: item.data.city,
                            networkName: item.data.networkName,
                            address: item.data.address,
                            children: item.data.children,
                        }
                    })
                })
            }
        },
        findClinicByName: function (name) {
            return this.axios.post('calltracking/clinicsAutocomplete', {
                q: name
            })
        },
        addClinic(clinic) {
            this.selectClinic = clinic
            this.foundClinics = [clinic]
        },
        setDate(date) {
            this.dateFilter = date
        }
    },
    watch: {
        foundClinics(value) {
            this.foundClinics = value
        },
        clinicExportOne(value) {
            if (!value) {
                this.selectClinic = {}
                this.foundClinics = []
            }
        }
    }
}
</script>

<style lang="scss">
    .custom-select {
        & .multiselect__content-wrapper {
            position: relative!important;
        }
    }
</style>
